import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import BigNumber from 'bignumber.js';
import {
  ConfirmDialogComponent,
  ConfirmDialogData,
} from 'src/app/modules/shared/components/dialogs/confirm-dialog/confirm-dialog.component';
import { AuthService } from '../../abstraction/auth.service';
import { CryptoService } from '../../abstraction/crypto.service';
import { IEmployee } from '../../models/User';
import { AddEmployeeDialogComponent } from './add-employee-dialog/add-employee-dialog.component';
import {
  AlertDialogComponent,
  AlertDialogData,
} from 'src/app/modules/shared/components/dialogs/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-payroll',
  templateUrl: './payroll.component.html',
  styleUrls: ['./payroll.component.scss'],
})
export class PayrollComponent implements OnInit {
  employees: IEmployee[];

  constructor(
    private dialog: MatDialog,
    private auth: AuthService,
    private cryptoSvc: CryptoService,
  ) {}

  ngOnInit(): void {
    this.auth.sendTikTokPageView(window.location.href).subscribe();
    this.auth.employees.subscribe((data) => {
      this.employees = data;
    });
  }

  sendPayments() {
    let daiPriceValue: string;
    if (this.auth.loggedUser.isCommerce)
      daiPriceValue = this.cryptoSvc.prices.value['DAI_ARS'].originalValue.sell;
    else {
      daiPriceValue = this.cryptoSvc.prices.value['DAI_ARS'].sell;
    }

    const daiPrice = new BigNumber(daiPriceValue);
    const amountToPay = new BigNumber(
      this.employees
        .reduce((prev: BigNumber, curr: IEmployee) => {
          let salary = new BigNumber(curr.salary);
          if (curr.isArs) {
            salary = salary.dividedBy(daiPrice);
          }
          return prev.plus(salary);
        }, new BigNumber('0'))
        .toFixed(2),
    );

    if (amountToPay.isEqualTo(0)) {
      this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
        panelClass: 'modal-container',
        data: {
          title: 'Operación Inválida',
          content: `No se puede realizar un pago de salarios por el total de 0 DAIs.`,
          isError: true,
        },
      });
      return;
    }

    const availableFunds = new BigNumber(this.auth.loggedUser.balance.crypto?.DAI?.amount || '0');
    if (amountToPay.isGreaterThan(availableFunds)) {
      this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
        panelClass: 'modal-container',
        data: {
          title: 'Fondos Insuficientes',
          content: `Faltan
          ${amountToPay.minus(availableFunds).toFixed(2)} DAIs para realizar esta operación.`,
          isError: true,
        },
      });
      return;
    }

    this.dialog
      .open<ConfirmDialogComponent, ConfirmDialogData>(ConfirmDialogComponent, {
        panelClass: 'modal-container',
        data: {
          title: 'Realizar pagos',
          content: `Estás por realizar el pago de los sueldos de tus empleados por
          ${amountToPay.toString()} DAIs`,
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.auth.sendPaymentsToEmployees().subscribe(() => {
            this.dialog.open<AlertDialogComponent, AlertDialogData>(AlertDialogComponent, {
              panelClass: 'modal-container',
              data: {
                title: 'Operación exitosa',
                content: `Se ha realizado una operación por ${amountToPay.toString()} DAIs`,
              },
            });

            const newCryptoPortfolio = this.auth.myCryptoPortfolio.value.map((crypto) => {
              if (crypto.ticker === 'DAI') {
                crypto.stocks = new BigNumber(crypto.stocks).minus(amountToPay).toString();
              }
              return crypto;
            });

            this.auth.myCryptoPortfolio.next(newCryptoPortfolio);

            const daiAmount = new BigNumber(this.auth.loggedUser.balance.crypto.DAI.amount);
            this.auth.loggedUser.balance.crypto.DAI.amount = daiAmount
              .minus(amountToPay)
              .toString();
            this.auth.loggedUserObs.next(this.auth.loggedUser);
          });
        }
      });
  }

  addEmployee() {
    this.dialog.open(AddEmployeeDialogComponent, {
      panelClass: 'modal-container',
    });
  }

  editEmployee(employee: IEmployee) {
    this.dialog.open(AddEmployeeDialogComponent, {
      panelClass: 'modal-container',
      data: {
        employeeToEdit: employee,
      },
    });
  }
}
